// extracted by css-extract-rspack-plugin
export default {"page":"QSdsa3kHh4Q63Eob","logo":"dr1psjKL_Z0qIxMJ","columns":"cgjTFwvFSLkb0kQA","marketing":"PKiJY04m0_8by1ch","content":"vzD_JQkT4lYJVUX5"};